export default __webpack_public_path__ + "static/media/bg-exclusive.7db64d72.webp";